import { runOnSportsWebInit } from '../bootstrap/run-on-sports-web.provider';
import { WebBridgeService } from './web-bridge.service';

export const provideEventBridge = () => runOnSportsWebInit(WebBridgeService);
